<div class="announcements-page">
  <div class="page-header">
    <div>
      <h3>{{ 'manageEvent.announcements.title' | translate }}</h3>
      <p class="text-muted">{{ 'manageEvent.announcements.subtitle' | translate }}</p>
    </div>
    <button class="btn btn-primary" (click)="openCreateForm()" [disabled]="showForm">
      <i class="fa fa-plus me-2"></i>
      {{ 'manageEvent.announcements.newAnnouncement' | translate }}
    </button>
  </div>

  @if (error) {
    <div class="alert alert-danger mb-4">{{ error }}</div>
  }

  @if (showForm) {
    <div class="announcement-form card mb-4">
      <div class="card-body">
        <h5 class="mb-4">{{ editingAnnouncement ? ('manageEvent.announcements.editAnnouncement' | translate) : ('manageEvent.announcements.newAnnouncement' | translate) }}</h5>

        <div class="mb-3">
          <label class="form-label fw-semibold">{{ 'manageEvent.announcements.titleLabel' | translate }} *</label>
          <input type="text"
                 class="form-control"
                 [(ngModel)]="formTitle"
                 [placeholder]="'manageEvent.announcements.titlePlaceholder' | translate">
        </div>

        <div class="mb-3">
          <label class="form-label fw-semibold">{{ 'manageEvent.announcements.description' | translate }}</label>
          <textarea class="form-control"
                    [(ngModel)]="formDescription"
                    rows="4"
                    [placeholder]="'manageEvent.announcements.descriptionPlaceholder' | translate"></textarea>
        </div>

        <div class="mb-4">
          <label class="form-label fw-semibold">{{ 'manageEvent.announcements.images' | translate }}</label>
          <div class="image-upload-area">
            <input type="file"
                   #fileInput
                   accept="image/*"
                   multiple
                   (change)="onFileSelected($event)"
                   style="display: none">
            <button type="button" class="btn btn-light-primary" (click)="fileInput.click()">
              <i class="fa fa-image me-2"></i>
              {{ 'manageEvent.announcements.addImages' | translate }}
            </button>
          </div>

          @if (selectedImages.length > 0) {
            <div class="selected-images mt-3">
              @for (file of selectedImages; track $index) {
                <div class="selected-image">
                  <span>{{ file.name }}</span>
                  <button type="button" class="btn-remove" (click)="removeSelectedImage($index)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              }
            </div>
          }

          @if (editingAnnouncement && editingAnnouncement.images.length > 0) {
            <div class="existing-images mt-3">
              <label class="form-label text-muted">{{ 'manageEvent.announcements.existingImages' | translate }}</label>
              <div class="image-grid">
                @for (image of editingAnnouncement.images; track image.image_id) {
                  <div class="image-item">
                    <img [src]="image.image_url" alt="Announcement image">
                    <button type="button" class="btn-delete-image" (click)="deleteImage(editingAnnouncement, image.image_id)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-light" (click)="cancelForm()" [disabled]="saving">
            {{ 'common.cancel' | translate }}
          </button>
          <button type="button"
                  class="btn btn-primary"
                  (click)="saveAnnouncement()"
                  [disabled]="saving || !formTitle.trim()">
            @if (saving) {
              <span class="spinner-border spinner-border-sm me-2"></span>
              {{ 'common.saving' | translate }}
            } @else {
              <i class="fa fa-check me-2"></i>
              {{ editingAnnouncement ? ('manageEvent.announcements.update' | translate) : ('manageEvent.announcements.publish' | translate) }}
            }
          </button>
        </div>
      </div>
    </div>
  }

  @if (loading) {
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p>{{ 'manageEvent.announcements.loading' | translate }}</p>
    </div>
  } @else if (announcements.length === 0 && !showForm) {
    <div class="empty-state">
      <i class="fa fa-bullhorn"></i>
      <h4>{{ 'manageEvent.announcements.noAnnouncements' | translate }}</h4>
      <p>{{ 'manageEvent.announcements.noAnnouncementsHint' | translate }}</p>
    </div>
  } @else {
    <div class="announcements-list">
      @for (announcement of announcements; track announcement.announcement_id) {
        <div class="announcement-card">
          <div class="announcement-header">
            <div class="announcement-info">
              <h5>{{ announcement.title }}</h5>
              <span class="announcement-date">
                <i class="fa fa-clock me-1"></i>
                {{ formatDate(announcement.created_at) }}
              </span>
            </div>
            <div class="announcement-actions d-flex gap-2">
              <app-button
                [variant]="'outline'"
                [size]="'sm'"
                [iconClass]="'fa fa-pen'"
                (clicked)="openEditForm(announcement)"
              />
              <app-button
                [variant]="'danger'"
                [size]="'sm'"
                [iconClass]="'fa fa-trash'"
                (clicked)="deleteAnnouncement(announcement)"
              />
            </div>
          </div>

          @if (announcement.description) {
            <div class="announcement-body">
              <p>{{ announcement.description }}</p>
            </div>
          }

          @if (announcement.images && announcement.images.length > 0) {
            <div class="announcement-images">
              @for (image of announcement.images; track image.image_id) {
                <div class="announcement-image">
                  <img [src]="image.image_url" alt="Announcement image">
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
